let lastScrollTop = 0;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

window.addEventListener("DOMContentLoaded", function () {
  // window.addEventListener("scroll", scrolling);

  window.addEventListener("scroll", scrolling);

  if (this.document.querySelector(".parallax")) {
    gsap.to(".parallax", {
      y: () => {
        const imageHeight = document.querySelector(".parallax").offsetHeight;
        const containerHeight = window.innerHeight;
        return (imageHeight - containerHeight) * -1; // Déplacement parfait
      },
      ease: "none",
      scrollTrigger: {
        trigger: ".parallax-container",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });
  }

  document.querySelectorAll(".hub_link").forEach((el) => {
    const textToAnimate = el;
    new SplitText(textToAnimate, { type: "lines" });
    new SplitText(textToAnimate, { type: "lines" });
  });

  document.querySelectorAll(".h2").forEach((el) => {
    // observerParallax.observe(el);

    const textToAnimate = el;
    new SplitText(textToAnimate, { type: "lines" });
    new SplitText(textToAnimate, { type: "lines" });

    const textDiv = el.querySelectorAll("& > div");
    const textDivDiv = el.querySelectorAll("& > div > div");
    gsap.set(el, { opacity: 1 });
    gsap.set(textDiv, { overflow: "hidden" });
    gsap.set(textDivDiv, { y: "-110%" });
    gsap.set(textDivDiv, { rotate: "-5deg" });

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      once: true,
      onEnter: () => {
        gsap.to(textDivDiv, {
          stagger: 0.05,
          delay: 0.2,
          duration: 0.8,
          y: 0,
          rotate: 0,
          ease: "expo.out",
        });
      },
    });
  });

  if (document.querySelector(".product-firstPrint_container:not(.hidden)")) {
    firstPrint_anim();
  }

  if (document.querySelector(".product-prestige_container:not(.hidden)")) {
    prestige_anim();
  }

  // Watch for wishlist toast notification and refresh cart when it appears
  let wishlistToastProcessed = false; // Flag to track if we've processed a toast

  const wishlistObserver = new MutationObserver((mutations) => {
    console.log("observing...");
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        // Check if our target element exists in the DOM and if we haven't processed it yet
        const toastElement = document.querySelector(
          ".shopify-block #iwish-drawer-root .transfer-product-note.toast-body",
        );

        if (toastElement && !wishlistToastProcessed) {
          console.log("toas found !");
          // Set flag to true to prevent multiple calls
          wishlistToastProcessed = true;

          // Call updateCart when the element appears
          window.updateCart();

          // Reset the flag after the toast disappears (typically a few seconds)
          setTimeout(() => {
            wishlistToastProcessed = false;
          }, 3000); // 3 seconds should be enough for most toasts
        }
      }
    }
  });

  // Start observing the entire document for changes
  wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.querySelectorAll(".h1").forEach((el) => {
    // observerParallax.observe(el);

    const textToAnimate = el;
    new SplitText(textToAnimate, { type: "lines" });
    new SplitText(textToAnimate, { type: "lines" });

    const textDiv = el.querySelectorAll("& > div");
    const textDivDiv = el.querySelectorAll("& > div > div");
    gsap.set(el, { opacity: 1 });
    gsap.set(textDiv, { overflow: "hidden" });
    gsap.set(textDivDiv, { y: "-110%" });
    gsap.set(textDivDiv, { rotate: "-5deg" });
    let delay = 0.2;
    if (el.dataset.delay != null) {
      delay = 0.2 + Number(el.dataset.delay);
    }

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      once: true,
      onEnter: () => {
        gsap.to(textDivDiv, {
          stagger: 0.05,
          delay: delay,
          duration: 0.7,
          y: 0,
          rotate: 0,
          ease: "expo.out",
        });
      },
    });
  });
});

function scrolling() {
  // document.documentElement.classList?.remove("nav-open");
  // let scrollTop = window.scrollY || document.documentElement.scrollTop;
  // window.scrollY > 100 && scrollTop > lastScrollTop
  //   ? document.documentElement.classList.add("scroll-down")
  //   : document.documentElement.classList.remove("scroll-down");
  // lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  // if (window.scrollY > 10) document.documentElement.classList.add("not-top");
  // else document.documentElement.classList.remove("not-top");

  const announce_bar = document.querySelector(
    "#shopify-section-announcement-bar",
  )
    ? Math.max(
        document.querySelector("#shopify-section-announcement-bar")
          .offsetHeight -
          document
            .querySelector("#shopify-section-announcement-bar")
            .getBoundingClientRect().top *
            -1,
        0,
      )
    : 0;

  const menu_top = 66 + announce_bar;
  const menu_height =
    window.innerHeight -
    document.querySelector("#shopify-section-header").offsetHeight -
    announce_bar -
    6;

  document.documentElement.style.setProperty(
    "--menuHeight",
    menu_height + "px",
  );

  document.documentElement.style.setProperty("--menuTop", menu_top + "px");

  if (this.document.querySelector("body.template-product")) {
    if (window.innerWidth <= 1024) {
      if (
        window.scrollY > 10 &&
        document
          .querySelector("#shopify-section-footer")
          .getBoundingClientRect().top -
          window.innerHeight >
          0
      )
        document
          .querySelector("#mobile_nav")
          .classList.remove("translate-y-full");
      else
        document.querySelector("#mobile_nav").classList.add("translate-y-full");
    }
  }
}

function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: "smooth",
  });
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;
  currentValue--;
  if (currentValue == 1)
    e.parentNode.querySelector('[onclick^="minQuantity"]').classList.add("off");
  e.parentNode.querySelector("input").value = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
      if (document.querySelector(".cart-premium_swiper")) {
        new Swiper(".cart-premium_swiper", {
          navigation: {
            prevEl: ".cart-premium_nav div:first-of-type",
            nextEl: ".cart-premium_nav div:last-of-type",
          },
          preventClicks: false,
          preventClicksPropagation: false,
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 1.45,
              spaceBetween: 10,
            },
          },
        });
      }
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

function fetchCartUpdateQty(el, itemId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));
}

window.cartUpdateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartReduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartIncreaseQty = (el) => {
  const maxStock = parseInt(el.getAttribute("max"));
  if (maxStock <= 0) return;

  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  let quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );

  if (quantity == maxStock) {
    document.querySelector("#cart-drawer")?.classList.remove("loading");
    return;
  }

  quantity++;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        if (document.querySelector(".product_errors")) {
          el.parentNode.parentNode.parentNode
            .querySelector(".product_errors")
            .classList.remove("hidden");
          el.parentNode.parentNode.parentNode.querySelector(
            ".product_errors_message",
          ).textContent = erreurs;
        }
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  fetchCartUpdateQty(el, itemId, 0);
  return false;
};

function removeNonPreorderItems() {
  return fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let itemsToRemove = cart.items.filter(
        (item) => !item.properties?.Sortie || item.properties.Sortie == "",
      );

      if (itemsToRemove.length === 0) return;

      let updates = {};
      itemsToRemove.forEach((item) => {
        updates[item.key] = 0; // Set quantity to 0 for removal
      });

      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    });
}

function removePreorderItems() {
  return fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let itemsToRemove = cart.items.filter(
        (item) => item.properties.Sortie != "",
      );

      if (itemsToRemove.length === 0) return;

      let updates = {};
      itemsToRemove.forEach((item) => {
        updates[item.key] = 0; // Set quantity to 0 for removal
      });

      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    });
}

function emptyCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
  });
}

// window.emptyCart = () => {
//   fetch("/cart/clear.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       console.log("Panier vidé avec succès", data);
//     })
//     .catch((error) => {
//       console.error("Erreur emptyCart :", error);
//     });
// };

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}

function customAddToCart(e) {
  e.preventDefault();
  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));
  console.log(formData);

  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key];
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;

  let addToCartAction = () => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        const erreurs = data.errors || data.description;
        if (erreurs) {
          addToCartErrors(erreurs);
          e.target.querySelector('[type="submit"]').disabled = false;
          return false;
        } else {
          hideAddToCartErrors();
        }
        updateCart(data);
        document.documentElement.classList.add("cart-drawer");
        e.target.querySelector('[type="submit"]').disabled = false;
      })
      .catch((error) => {
        if (document.querySelector(".product_errors")) {
          e.target.querySelector(".product_errors").classList.remove("hidden");
          console.error("Erreur :", error);
        }
      });
  };

  addToCartAction();
}

function checkPreco(e) {}
function addToCartErrors(message) {
  document.querySelector(".product_errors").classList.remove("hidden");
  document.querySelector(".product_errors_message").textContent =
    "Veuillez choisir une édition";
  return false;
}

function hideAddToCartErrors() {
  document.querySelector(".product_errors").classList.add("hidden");
}

function faqToggle(element) {
  const body = element.nextElementSibling;
  const maxHeight = body.scrollHeight + "px";

  // if (body.style.maxHeight === maxHeight) {
  //   body.style.maxHeight = "0";
  //   element.parentNode.classList.remove("active");
  // } else {
  //   body.style.maxHeight = maxHeight;
  //   element.parentNode.classList.add("active");
  // }

  if (element.parentNode.classList.contains("active")) {
    element.parentNode.classList.remove("active");
    body.style.maxHeight = "0";
  } else {
    if (document.querySelector(".faq_item.active")) {
      document.querySelector(".faq_item.active .faq_body").style.maxHeight =
        "0";
      document.querySelector(".faq_item.active").classList.remove("active");
    }
    element.parentNode.classList.add("active");
    body.style.maxHeight = maxHeight;
  }
}

function toggle(element) {
  const body = element.nextElementSibling;
  const maxHeight = body.scrollHeight + "px";

  // if (body.style.maxHeight === maxHeight) {
  //   body.style.maxHeight = "0";
  //   element.parentNode.classList.remove("active");
  // } else {
  //   body.style.maxHeight = maxHeight;
  //   element.parentNode.classList.add("active");
  // }

  if (element.parentNode.classList.contains("active")) {
    element.parentNode.classList.remove("active");
    body.style.maxHeight = "0";
  } else {
    if (document.querySelector(".toggle_item.active")) {
      document.querySelector(
        ".toggle_item.active .toggle_body",
      ).style.maxHeight = "0";
      document.querySelector(".toggle_item.active").classList.remove("active");
    }
    element.parentNode.classList.add("active");
    body.style.maxHeight = maxHeight;
  }
}

function firstPrint_anim() {
  const img1 = this.document.querySelectorAll(
    ".product-firstPrint_container .product-shadow-firstPrint",
  )[1];
  const img2 = this.document.querySelectorAll(
    ".product-firstPrint_container .product-shadow-firstPrint",
  )[2];
  ScrollTrigger.create({
    trigger: ".product-firstPrint_container",
    start: "top 75%",
    end: "bottom top",
    once: true,
    onEnter: () => {
      gsap.fromTo(
        img1,
        {
          y: 0,
          x: 0,
          rotate: 0,
        },
        {
          duration: 0.6,
          y: "15px",
          x: "30px",
          rotate: 10,
          ease: "expo.out",
        },
      );

      gsap.fromTo(
        img2,
        {
          y: 0,
          x: 0,
          rotate: 0,
        },
        {
          duration: 0.6,
          y: "30px",
          x: "60px",
          rotate: 20,
          ease: "expo.out",
        },
      );
    },
  });
}

function prestige_anim() {
  const img1 = this.document.querySelectorAll(
    ".product-prestige_container .product-shadow-firstPrint",
  )[1];
  const img2 = this.document.querySelectorAll(
    ".product-prestige_container .product-shadow-firstPrint",
  )[2];
  ScrollTrigger.create({
    trigger: ".product-prestige_container",
    start: "top 75%",
    end: "bottom top",
    once: true,
    onEnter: () => {
      gsap.fromTo(
        img1,
        {
          y: 0,
          x: 0,
          rotate: 0,
        },
        {
          duration: 0.6,
          y: "15px",
          x: "30px",
          rotate: 10,
          ease: "expo.out",
        },
      );

      gsap.fromTo(
        img2,
        {
          y: 0,
          x: 0,
          rotate: 0,
        },
        {
          duration: 0.6,
          y: "30px",
          x: "60px",
          rotate: 20,
          ease: "expo.out",
        },
      );
    },
  });
}
